import { AppDispatch, RootState } from '../../redux/store'
import { deleteResourceCascade } from '../../datastore'

export const deleteTa = (taId: number) => (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch(deleteResourceCascade(taId, 'tas', ['taWorkers']))
}